jQuery(document).ready(function($){

  /*=======================================
  VALIDATE LOST PASSWORD FORM
  =======================================*/
  $('#lost-password-form').validate({

    rules: {
      email: {
        required: true,
        email: true
      }
    },

    messages: {
      email: {
        required: window.trans.get('messages.lost_password.validation.email.required'),
        email: window.trans.get('messages.lost_password.validation.email.format')
      }
    },

    onfocusout: function(element) {
      this.element(element);
    },

    submitHandler: function(){
      lost_password_handle_data();
    }

  })

  /*=======================================
  VALIDATE RESET PASSWORD FORM
  =======================================*/
  $('#reset-password-form').validate({

    rules: {
      password: {
        required: true,
        minlength: 9
      },
      password_confirmation: {
        equalTo: '#new_password'
      }
    },

    messages: {
      password: {
        required: window.trans.get('messages.restore_password.validation.password.required'),
        minlength: window.trans.get('messages.restore_password.validation.password.length')
      },
      password_confirmation: {
        equalTo: window.trans.get('messages.restore_password.validation.password_confirmation')
      }
    },

    onfocusout: function(element) {
      this.element(element);
    },

    submitHandler: function(){
      reset_password_handle_data();
    }

  })

  /*=======================================
  HANDLE LOST PASSWORD FORM
  =======================================*/
  function lost_password_handle_data(){

    var form = $('#lost-password-form');
    var button = form.find('button[type="submit"]');
    var token = form.find('input[name="_token"]');

    $.ajax({

      method: 'post',
      url: '/lost-password',
      headers: {
        'X-CSRF-TOKEN': $('#app').find('input[name="global_token"]').val()
      },
      data: {
        email: form.find('input[name="email"]').val()
      },
      dataType: 'json',
      beforeSend: function(){
        button.addClass('loading');
      },
      complete: function(){
        button.removeClass('loading');
      },
      error: function(xhr){

        console.log(xhr);

        switch (xhr.status) {

          case 422:
            form.bonin_form_message({
              type: 'error',
              message: window.trans.get('messages.lost_password.errors.no_user')
            });
          break;

          default:
            $.bonin_app_message({
              type: 'error',
              message: window.trans.get('messages.lost_password.errors.internal_error')
            });
          break;

        }

      },
      success: function(data){

        $.bonin_app_message({
          type: 'success',
          message: window.trans.get('messages.lost_password.success.message')
        });

        form.bonin_form_message({
          type: 'success',
          message: window.trans.get('messages.lost_password.success.form')
        })

        form[0].reset();

      } // ajax.success

    }) // ajax.call

  }

  /*=======================================
  HANDLE RESET PASSWORD FORM
  =======================================*/
  function reset_password_handle_data(){

    var form = $('#reset-password-form');
    var button = form.find('button[type="submit"]');
    var token = form.find('input[name="_token"]');

    $.ajax({

      method: 'post',
      url: window.location.pathname,
      // headers: {
      //   'X-CSRF-TOKEN': $('input[name="global_token"]').val()
      // },
      data: {
        password: form.find('input[name="password"]').val(),
        password_confirmation: form.find('input[name="password_confirmation"]').val(),
        credential_id: form.find('input[name="credential_id"]').val(),
        key: form.find('input[name="key"]').val(),
        key_id: form.find('input[name="key_id"]').val()
      },
      dataType: 'json',
      beforeSend: function(){
        button.addClass('loading');
      },
      complete: function(){
        button.removeClass('loading');
      },
      error: function(xhr){

        console.log(xhr);

        switch (xhr.status) {

          case 422:
          $.bonin_app_message({
            type: 'error',
            message: window.trans.get('messages.restore_password.error.form_data')
          });
          break;

          default:
          $.bonin_app_message({
            type: 'error',
            message: window.trans.get('messages.restore_password.error.internal_error')
          });

        }

      },
      success: function(data){

        form.bonin_form_message({
          type: 'success',
          message: '<a href="'+data.login_page+'">' + window.trans.get('messages.restore_password.success.form') + '</a>'
        })

        $.bonin_app_message({
          type: 'success',
          message: window.trans.get('messages.restore_password.success.message')
        });

        form[0].reset();

      } // ajax.success

    }) // ajax.call

  }


}) // document.ready
